import { Injectable, ViewContainerRef } from '@angular/core';

@Injectable()
export class ShellService {
  vcr: ViewContainerRef;

  setRootElement(vcr: ViewContainerRef) {
    this.vcr = vcr;
  }

  getRootElement() {
    return this.vcr;
  }

  clearRootElement() {
    this.vcr = null;
  }
}



// WEBPACK FOOTER //
// /azp/_work/1/s/src/app/core/services/shell.service.ts